var map = {
	"./favicon-1.png": "59f5",
	"./favicon.png": "8925e",
	"./horizontal.jpg": "819e",
	"./logo_login-1.png": "f840",
	"./logo_login-2.png": "87d6",
	"./logo_login.png": "ff4a",
	"./logo_login2.png": "4f2c",
	"./user-1.png": "5b3c",
	"./user-2.png": "fdbe",
	"./user.png": "ba97"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";